import React from 'react'
import ReactAutoSuggestDropdown from '../../ui/AutoSuggestionDropdown'
import { Form, FormGroup, InputGroup, Button, Table } from 'reactstrap'
import Loader from 'react-loader-spinner'
import '../../../stylesheets/Provision.css'
import { subscriptionHelpers } from '../../../dataHelpers'
import { TOKEN_STORAGE_KEY, getStorage } from "../../../dataHelpers/authenticationHelpers"
import { AppError } from "../../../models"
import { ErrorModal } from '../../ui'
import { NO_VALUE, ENTER_CONTROLLER_PHONE, NOT_FOUND, PAY_HISTORY_NOT_FOUND } from '../../../constants'

class PaymentHistory extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            errors: [],
            loading: false,
            subscriptionControllers: [],
            selectController: '',
            paymentHistoryData: [],
            chosenValue: '',
            searchValue: '',
            showDropdown: false,
        }
        this.token = (props.token || JSON.parse(getStorage().getItem(TOKEN_STORAGE_KEY)))
        this.handleSubmit = this.handleSubmit.bind(this)
        this.chooseDropdownItem = this.chooseDropdownItem.bind(this)
        this.updateSearchValue = this.updateSearchValue.bind(this)
        this.showDropdown = this.showDropdown.bind(this)
    }

    async componentDidMount() {
        this.getSubsControllerList(this.token)
    }

    async getSubsControllerList(token) {
        try {
            let subscriptionList = await subscriptionHelpers.getSubscriptionControllers(token)
            if (!subscriptionList.error) {
                this.setState({ subscriptionControllers: subscriptionList })
            } else {
                this.setState({ errors: [subscriptionList.error] })
            }
        } catch (error) {
            console.log(error)
        }
    }

    chooseDropdownItem(e, valueSelected, valueObject) {
        e.preventDefault()
        let selectId = this.state.subscriptionControllers.filter(function (e) { return e.serial_number === valueSelected; })
        this.setState({
            showDropdown: false,
            searchValue: valueSelected,
            selectController: selectId[0].controller,
            paymentHistoryData: []
        })
    }

    updateSearchValue(e) {
        e.preventDefault()
        if (e.target.value) {
            let value = e.target.value
            this.setState({ searchValue: e.target.value })
            let selectId = this.state.subscriptionControllers.filter(function (e) { return e.serial_number === value })
            if(selectId.length>0){
                this.setState({selectController: selectId[0].controller})
            }else{
                this.setState({selectController:''})
            }

        } else {
            this.setState({
                searchValue: e.target.value,
                selectController: '',
                paymentHistoryData: []
            })
        }
    }

    showDropdown() {
        this.setState({ showDropdown: true })
    }

    async handleSubmit(e) {
        e.preventDefault()
        this.setState({ loading: true })
        try {
            const{searchValue} = this.state
            let controllerId = (this.state.selectController).toString()
            if((searchValue.length > 0) && (!controllerId || !controllerId.length)){
                let appError = new AppError(NO_VALUE, PAY_HISTORY_NOT_FOUND)
                await this.setState({ errors: [appError], loading: false, paymentHistoryData: [] })
                return
            }
            if ((!controllerId || !controllerId.length) && (searchValue.length == 0)) {
                let appError = new AppError(NO_VALUE, ENTER_CONTROLLER_PHONE)
                await this.setState({ errors: [appError], loading: false })
                return
            }
            let paymentHistoryResponse = await subscriptionHelpers.getPaymentHistory(this.token, controllerId)
            if (!paymentHistoryResponse.error) {
                if (paymentHistoryResponse.length > 0) {
                    await this.setState({ paymentHistoryData: paymentHistoryResponse, loading: false })
                } else {
                    let appError = new AppError(NOT_FOUND, PAY_HISTORY_NOT_FOUND)
                    await this.setState({ errors: [appError], loading: false, paymentHistoryData: '' })
                }
            } else {
                this.setState({ errors: [paymentHistoryResponse.error] })
            }
        } catch (error) {
            console.log(error)
        }
    }

    dismissError(error) {
        let errors = this.state.errors.filter((e) => e !== error)
        this.setState({ errors, loading: false })
    }

    IsJsonString(str) {
        try {
            return JSON.parse(str);
        } catch (e) {
            return null;
        }
    }

    render() {
        let { loading, errors, subscriptionControllers, paymentHistoryData } = this.state

        return (<div className="row justify-content-center align-items-center">
            <h1 className="col-12 setHeading">Payment History Marksman Controller</h1>
            <br />
            {errors.map((appError, idx) =>
                <ErrorModal key={`error-${appError.text}-${idx}`}
                    modal={true}
                    toggle={() => (this.dismissError(appError))}
                    text={appError.text}
                    title={appError.title} />
            )}
            <br />

            {(loading ?
                <Loader type="TailSpin" width={60} height={60} /> :
                <Form onSubmit={this.handleSubmit} className="col-lg-4 col-md-8 col-sm-10">
                    <FormGroup>
                        <br />
                        <InputGroup>
                            <ReactAutoSuggestDropdown
                                list={subscriptionControllers}
                                showDropdown={this.showDropdown}
                                displayDropdownMenu={this.state.showDropdown}
                                chosenValue={this.state.chosenValue}
                                chooseDropdownItem={this.chooseDropdownItem}
                                updateSearchValue={this.updateSearchValue}
                                searchValue={this.state.searchValue}
                                highlightColour={"#ff9966"}
                                placeholder="Serial Number"
                            />
                        </InputGroup>
                    </FormGroup>
                    <br />
                    <Button>View</Button>
                </Form>
            )}
            {(paymentHistoryData.length > 0 ?
                <div id="provisioned-controllers" className="col-md-12 overflow-auto justify-content-center align-items-center">
                    <h3 class="setHeading">Payment Details</h3>
                    <div class="table-responsive">
                    <Table>
                        <tr>
                            <th>Transaction ID</th>
                            <th>Paid By</th>
                            <th>Amount</th>
                            <th>Payment Date</th>
                        </tr>
                        {paymentHistoryData.map((controller, idx) => {
                            let detail = this.IsJsonString(controller.detail)
                            let date = new Date(controller.payment_date)
                            let month = ((date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1))
                            let day = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate())
                            let year = date.getFullYear()
                            return (
                                <tr key={`${controller.id}-${idx}`}>
                                    <td>{controller.random_transaction_id}</td>
                                    <td>{controller.paid_by}</td>
                                    <td>{detail ? ('$ ' + (detail.amount) / 100) : ''}</td>
                                    <td>{
                                        month + '-' + day + '-' + year //mm-dd-yyyy
                                        //new Date(controller.payment_date).toISOString().slice(0, 10)
                                    }</td>
                                </tr>
                            )
                        })}
                    </Table>
                    </div>
                </div>
                : null)}
        </div>)
    }
}

export default PaymentHistory



// WEBPACK FOOTER //
// ./src/components/pages/subscription/PaymentHistory.js